// src/components/orders/OrdersTable.jsx
import React from "react";
import { Link } from "react-router-dom";
import { toApiDateTime } from "@lib/datetime";

const orderIdOf = (o) => String(o?.order_id ?? o?.id ?? "");

export default function OrdersTable({
  rows,
  selected,
  isAllOnPageSelected,
  isSomeOnPageSelected,
  onToggleOne,
  onToggleAllOnPage,
  jofotaraStatusById,
  processingOrderId,
}) {
  const headerRef = React.useRef(null);

  React.useEffect(() => {
    if (headerRef.current) {
      headerRef.current.indeterminate = Boolean(isSomeOnPageSelected);
    }
  }, [isSomeOnPageSelected]);

  return (
    <div className="oc-table-wrap">
      <table className="oc-table">
        <thead>
          <tr>
            <th style={{ width: 36 }}>
              <input
                ref={headerRef}
                type="checkbox"
                checked={Boolean(isAllOnPageSelected)}
                onChange={(e) => onToggleAllOnPage?.(e.target.checked)}
              />
            </th>
            <th>Order ID</th>
            <th>Customer</th>
            <th>Status</th>
            <th>Total</th>
            <th>Date Added</th>
            <th>Type</th>
            <th>Pickup time slot</th>
            <th>Dropoff time slot</th>
            <th style={{ width: 190 }}>JoFotara</th>
            <th style={{ width: 120 }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((o) => {
            const oid = orderIdOf(o);
            const cid = o.customer?.customer_id ?? o.customer_id;
            const cname = o.customer?.name ?? o.name ?? "";
            const status = o.status_name ?? o.status;

            const jf = jofotaraStatusById?.[oid];
            const jfState = jf?.state || "idle";
            const jfMsg = jf?.message || "";

            const isProcRow = processingOrderId && String(processingOrderId) === String(oid);
            const rowStyle = o.complemantary_reason ? { backgroundColor: "#efd9d9" } : {};

            return (
              <tr key={oid} style={rowStyle}>
                <td>
                  <input
                    type="checkbox"
                    checked={selected?.has?.(oid) || false}
                    onChange={() => onToggleOne?.(oid)}
                  />
                </td>

                <td className="oc-mono">{oid}</td>

                <td>
                  {cid ? (
                    <Link to={`/customers/${cid}`}>{cname}</Link>
                  ) : (
                    cname
                  )}
                </td>

                <td>
                  {status === "Pick up" && <span className="oc-badge blue">Pick up</span>}
                  {status === "Processing" && <span className="oc-badge amber">Processing</span>}
                  {status === "Cleaning" && <span className="oc-badge green">Cleaning</span>}
                  {status === "Delivery" && <span className="oc-badge red">Delivery</span>}
                  {status === "Complete" && <span className="oc-badge green">Complete</span>}
                  {status === "Canceled" && <span className="oc-badge red">Canceled</span>}
                  {status === "Chargeback" && <span className="oc-badge pink">Chargeback</span>}
                  {status === "Skip Selection" && <span className="oc-badge orange">Skip Selection</span>}
                  {status === "Reschedule" && <span className="oc-badge amber">Reschedule</span>}
                  {status === "Pending for customer support" && <span className="oc-badge red">Pending for customer support</span>}
                  {!["Pick up", "Processing", "Cleaning", "Delivery", "Complete", "Canceled", "Chargeback", "Skip Selection", "Reschedule", "Pending for customer support"].includes(status) && (
                    <span className="oc-badge gray">{status}</span>
                  )}
                </td>

                <td className="oc-mono">{isNaN(Number(o.total)) ? o.total : Number(o.total || 0).toFixed(2)}</td>
                <td className="oc-mono">{toApiDateTime(o.date ?? o.date_added)}</td>
                <td>{o.type ?? o.order_type}</td>
                <td className="oc-mono">{o.pickup_time_slot ?? o.pickup_slot}</td>
                <td className="oc-mono">{o.dropoff_time_slot ?? o.dropoff_slot}</td>

                <td>
                  {isProcRow && <span className="oc-badge blue" title="Sending…">Sending…</span>}

                  {!isProcRow && jfState === "pass" && (
                    <span className="oc-badge green" title={jfMsg}>
                      Sent to JoFotara
                    </span>
                  )}

                  {!isProcRow && jfState === "processing" && (
                    <span className="oc-badge blue" title={jfMsg}>
                      Sending…
                    </span>
                  )}

                  {!isProcRow && jfState === "fail" && (
                    <span className="oc-badge red" title={jfMsg}>
                      Failed
                    </span>
                  )}

                  {!isProcRow && jfState === "idle" && (
                    <span className="oc-badge gray">—</span>
                  )}
                </td>

                <td>
                  <div className="oc-row-actions">
                    <Link to={`/orders/${o.order_id ?? o.id ?? oid}`}>
                      <button className="oc-ico-btn" title="View">👁️</button>
                    </Link>
                  </div>
                </td>
              </tr>
            );
          })}

          {rows.length === 0 && (
            <tr>
              <td colSpan={11} style={{ textAlign: "center", padding: 24 }}>
                No orders found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

